import React from "react";
import { Recipient } from "../../../../shared/models/user/recipient/recipient";
import Message from "../../../../components/message";
import { MessageSections } from "../../../../components/message/message";
import { PaperProps } from "@mui/material";
import { UserAddress } from "../../../../shared/models/user/user-address";
import { SingleAddress } from "../../user-addresses/single-address/single-address";
import BarekamButton, { SimpleButtons } from "../../../../components/button";
import BarekamText from "../../../../components/text";

export const RecipientAddress = ({ recipient, setAddressToEdit }: RecipientAddressProps) => {
    if (recipient.country) {
        const address = {
            country: recipient.country,
            province: recipient.province,
            city: recipient.city,
            region: recipient.region,
            street: recipient.street,
            building: recipient.building,
            entrance: recipient.entrance,
            floor: recipient.floor,
            apartment: recipient.apartment,
            zipCode: recipient.zipCode,

            addressId: -1,
            name: '',
            description: '',
            isDefault: false,
        } as UserAddress;

        return (
            <SingleAddress address={address} onAddressEdit={() => setAddressToEdit(address)} isReadonly />
        )
    } else {
        return (
            <BarekamButton type={SimpleButtons.LINK} onClick={() => setAddressToEdit({} as UserAddress)}>
                <BarekamText variant={'xl'} bold>
                    <Message messageKey={'add_address'} sectionId={MessageSections.ORDERS} />
                    <span style={{ display: 'inline', marginLeft: '8px' }}>*</span>
                </BarekamText>
            </BarekamButton>
        )
    }
}
interface RecipientAddressProps extends PaperProps {
    recipient: Recipient,
    setAddressToEdit: (address: UserAddress) => void;
}